// Vue
import { Component, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import UnimogCheckbox from "#/components/unimog_checkbox/UnimogCheckbox";
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { UnimogProduct } from "../../../common/interfaces/unimog/UnimogProduct";
import { UnimogPartner } from "../../../common/interfaces/unimog/UnimogPartner";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import UnimogProductSiegel from "../../../components/unimog_product_siegel/UnimogProductSiegel";
import EconicProductSiegel from "../../../components/econic_product_siegel/EconicProductSiegel";
import { DownloadLink } from "../../../components/download_link/DownloadLink";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    UnimogProductSiegel,
    EconicProductSiegel,
    DownloadLink,
  },
})
export class PageProductModule extends ModuleBase {
  private product: UnimogProduct | null = null;

  private isEconic: boolean = window.location.hostname.indexOf("econic") > 0;

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  public created() {
    let id = this.$store.page!.page!.route_parameter["id"];
    let slug = this.$store.page!.page!.route_parameter["slug"];

    if (id) {
      this.loadProduct(id, slug);
    }
  }

  private async loadProduct(id, slug) {
    this.product = await Api.unimog.getProduct(id, slug);
  }

  private get provedByText() {
    return this.lang == "de" ? "Geprüft von" : "Approved by";
  }

  private getDownloadText(download, i) {
    return (
      this.instance["translation"]["download_broschuere"] +
      (this.product!.downloads.length > 1 ? " " + (i + 1) : "") +
      (download.language ? " (" + download.language + ")" : "")
    );
  }
}
